// Core
import { Suspense } from 'react';
// Packages
import { Switch, Route } from 'react-router-dom';
// Pages
import NotFoundPage from 'pages/NotFoundPage';
// Components
import { AppLoader, ErrorBoundary, Loader, ReloadScreen } from 'components';
// Redux
import { STORE_KEYS, useAppSelector } from 'redux/store';
// Custom Hooks
import { useRoutePermissions } from 'customHooks';
// Routes
import routes, { ROUTES } from './routes';
import PublicRoute from 'router/PublicRoute';
import PrivateRoute from 'router/PrivateRoute';
import SignInAsAdmin from 'pages/SignInAsAdmin';

const AppRouter = () => {
  // ** useRoutePermissions:
  // ** If (!user) - returns only public routes;
  // ** If (user) - filtering routes according to Platform Permission (user.platformPermissions), sending from backend;
  // ** (checking if property 'read' is presented  in certain route);

  const allowedRoutes = useRoutePermissions(routes);
  const { isLoggedIn, userId } = useAppSelector(STORE_KEYS.AUTH);
  const { user, error } = useAppSelector(STORE_KEYS.USER);

  // Signed in but /users/me (user + permissions) hasn't answered: routes aren't known yet,
  // so any private URL would fall through to 404. Wait for it, or offer a reload if it failed.
  if (isLoggedIn && userId && !user) {
    return error ? <ReloadScreen /> : <AppLoader />;
  }

  return (
    <ErrorBoundary>
      <Suspense fallback={<Loader isLoading isRouteFallback />}>
        <Switch>
          {allowedRoutes.map(route =>
            route.private ? (
              <PrivateRoute key={route.path} {...route} />
            ) : (
              <PublicRoute key={route.path} {...route} />
            ),
          )}

          <Route exact path={ROUTES.SIGN_IN_AS_ADMIN} component={SignInAsAdmin} />

          <Route component={NotFoundPage} />
        </Switch>
      </Suspense>
    </ErrorBoundary>
  );
};

export default AppRouter;
